import React, { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register, lang } = useApp();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const ref = searchParams.get("ref");
    if (ref) setReferralCode(ref.toUpperCase());
  }, [searchParams]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(email, password, name);
      toast.success("Welcome to Havana Casino!");
      if (referralCode) {
        try {
          const r = await api.post("/referrals/apply", { code: referralCode.trim().toUpperCase() });
          toast.success(`+${r.data.reward_gc.toLocaleString()} GC welcome bonus from your friend!`);
        } catch (err) { /* silent */ }
      }
      nav("/lobby");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  const onGoogle = () => {
    const redirectUrl = window.location.origin + "/lobby" + (referralCode ? `?ref=${referralCode}` : "");
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="lux-card p-10">
        <h1 className="font-serif text-3xl gold-text text-center mb-2">{t(lang,"auth.signup")}</h1>
        <p className="text-center text-white/40 text-xs mb-8">{t(lang,"auth.welcome_bonus")}</p>
        {referralCode && (
          <div className="bg-emerald-950/30 border border-emerald-500/30 rounded-md px-3 py-2 mb-4 text-xs text-emerald-300 text-center">
            🎁 Referral code: <strong>{referralCode}</strong> · +5,000 GC bonus on signup
          </div>
        )}
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">{t(lang,"auth.name")}</label>
            <input data-testid="register-name" required value={name} onChange={e=>setName(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 focus:border-[#d4af37] focus:outline-none"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">{t(lang,"auth.email")}</label>
            <input data-testid="register-email" required type="email" value={email} onChange={e=>setEmail(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 focus:border-[#d4af37] focus:outline-none"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">{t(lang,"auth.password")}</label>
            <input data-testid="register-password" required type="password" minLength={6} value={password} onChange={e=>setPassword(e.target.value)}
              className="w-full mt-1 px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 focus:border-[#d4af37] focus:outline-none"/>
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-white/50">Referral code (optional)</label>
            <input data-testid="register-refcode" value={referralCode} onChange={e=>setReferralCode(e.target.value.toUpperCase())}
              placeholder="ABCD1234"
              className="w-full mt-1 px-4 py-3 rounded-md bg-[#1a1a1a] border border-white/10 focus:border-[#d4af37] focus:outline-none uppercase"/>
          </div>
          <button data-testid="register-submit" disabled={loading} className="btn-gold w-full py-3 rounded-md">{loading?"…":t(lang,"auth.signup")}</button>
        </form>
        <div className="my-5 flex items-center gap-3 text-white/30 text-xs"><div className="flex-1 h-px bg-white/10"/>{t(lang,"auth.or")}<div className="flex-1 h-px bg-white/10"/></div>
        <button data-testid="google-register" onClick={onGoogle} className="btn-ghost w-full py-3 rounded-md text-sm">{t(lang,"auth.google")}</button>
        <p className="text-center text-xs text-white/50 mt-6">{t(lang,"auth.have_account")} <Link to="/login" className="text-[#d4af37]">{t(lang,"auth.signin")}</Link></p>
      </div>
    </div>
  );
}
